import { API, graphqlOperation } from "aws-amplify";
import { GraphQLResult } from "@aws-amplify/api";
import {  promptsByProjectIdAndKey } from "../graphql/queries";
import {  PromptsByProjectIdAndKeyQuery } from "../API";



export async function fetchLLMPrompts(
  projectId: string
): Promise<GraphQLResult<PromptsByProjectIdAndKeyQuery>> {
  
  return API.graphql(
    graphqlOperation( promptsByProjectIdAndKey, {
      projectId: projectId,
    })
  ) as Promise<GraphQLResult<PromptsByProjectIdAndKeyQuery>>;
}